// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2mrtg","main":"styles_main__RVS7x","header":"styles_header__5wleR","toggleButton":"styles_toggleButton__x9+68","content":"styles_content__2PqRD"};